import {
	ProductsStateActions,
	FETCH_CONFIG_PENDING,
	FETCH_CONFIG_SUCCESS,
	FETCH_CONFIG_FAILURE,
} from './types';
import { ProductData } from '@ikea-aoa/component-view-3d';
import {
	GalleryItem,
	MissingProductItem,
	ProductInfo,
	ShoppingGalleryItem,
} from 'sofa-reborn-react';

export function fetchConfigPending(): ProductsStateActions {
	return {
		type: FETCH_CONFIG_PENDING,
	};
}

export function fetchConfigSuccess(
	productInfo: ProductInfo | null,
	products: ProductData,
	galleryItems: GalleryItem[],
	missingProducts: MissingProductItem[],
	galleryShoppingProducts: ShoppingGalleryItem[]
): ProductsStateActions {
	return {
		type: FETCH_CONFIG_SUCCESS,
		productInfo,
		products,
		galleryItems,
		missingProducts,
		galleryShoppingProducts,
	};
}

export function fetchConfigFailure(error: ErrorEvent): ProductsStateActions {
	return {
		type: FETCH_CONFIG_FAILURE,
		message: error.message,
	};
}
